import Vue from 'vue';

const success = (data, id, resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(errors);
};

export default (id, orderProduct, orderProductId) => (
  new Promise((resolve, reject) => {
    Vue.$http
    .put(`/orders/${id}/products/${orderProductId}/batch-update`, orderProduct)
    .then((response) => {
      success(response.data, id, resolve);
    })
    .catch((error) => {
      failed(error.response.data, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/orderProduct/batchUpdate.js